import { lineMetricsAtOffset } from "./lineMetrics.js";

/**
 * Notepad++-style rectangular clip: lines `l0..l1` (0-based), columns `c0..c1` (0-based inclusive).
 * Short lines are padded with spaces on the right to `c1`.
 */
export function buildColumnBlockPlainText(text: string, anchorOffset: number, focusOffset: number): string {
  const a = lineMetricsAtOffset(text, anchorOffset);
  const b = lineMetricsAtOffset(text, focusOffset);
  const l0 = Math.min(a.lineIndex0, b.lineIndex0);
  const l1 = Math.max(a.lineIndex0, b.lineIndex0);
  const c0 = Math.min(a.col1 - 1, b.col1 - 1);
  const c1 = Math.max(a.col1 - 1, b.col1 - 1);
  const lines = text.split(/\r?\n/);
  const out: string[] = [];
  for (let li = l0; li <= l1; li++) {
    const line = lines[li] ?? "";
    let row = "";
    for (let c = c0; c <= c1; c++) {
      row += c < line.length ? line[c]! : " ";
    }
    out.push(row);
  }
  return out.join("\n");
}
